module.exports = __webpack_public_path__ + "img/ua.6ef5911.svg";